import React from 'react';
import { useEventParticipants } from '../../../../../../data/hooks/participant/useEventParticipants';
import TogglableUserList from '../../common/TogglableUserList';

function InviteParticipants(props) {
    const { eventId, selected, onChange } = props,
        allParticipants = useEventParticipants(eventId);

    return <TogglableUserList all={allParticipants} selected={selected} onChange={onChange} />;
}

export default InviteParticipants;
